"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var component = function (props) { return (React.createElement("div", { className: 'sso-button-container' },
    React.createElement("div", null,
        React.createElement("h3", null, (0, translation_1.getLocalization)('sso/links/header')),
        React.createElement("hr", { className: 'title' }),
        React.createElement("div", { className: 'buttons' },
            props.status === 'FETCHED' &&
                props.list.map(function (sso) { return (React.createElement(sok_ui_1.Button, { color: 'dark-blue', size: 'large', url: "/sso/".concat(sso.provider) }, sso.name)); }),
            props.status === 'FETCHING' && React.createElement(sok_ui_1.LoadingSpinner, null),
            props.status === 'FAILURE' && (React.createElement("div", null, (0, translation_1.getLocalization)('sso/links/unableFetchOrganisationLinks'))))))); };
exports.default = component;
